import type { RouterInputs, RouterOutputs } from "@/trpc";

export type LicenseSources = RouterOutputs["psv"]["listStateLicenseSources"];
export type LicenseSource = LicenseSources["sources"][number];
export type VerificationRun = RouterOutputs["psv"]["getRun"];
export type VerificationCheck = VerificationRun["checks"][number];
export type VerificationResult = NonNullable<
  VerificationCheck["results"]
>[number];
export type StartVerification = RouterInputs["psv"]["startVerificationRun"];
export type VerificationSelection = Pick<
  StartVerification,
  "sourceIds" | "licenseIds" | "allowNameSearch" | "npi"
>;
export type VerificationFormActions = {
  pending: boolean;
  onSubmit: (selection: VerificationSelection) => void;
  onCancel: () => void;
};
export type ProviderScope = Pick<
  StartVerification,
  "organizationBusinessUnitId" | "providerUserId" | "expectedAffiliationId"
>;
export type ProviderReadScope = Omit<RouterInputs["psv"]["getRun"], "runId">;

export const LOOKUP_METHOD = {
  LicenseId: "license-id",
  Name: "name",
  Npi: "npi",
} as const;
export const NPI_PATTERN = /^\d{10}$/;

export const CHECK_STATUS_LABELS: Record<VerificationCheck["status"], string> =
  {
    queued: "Waiting to start",
    running: "Checking records",
    "retry-wait": "Waiting to retry",
    collected: "Records collected",
    blocked: "Unable to complete this check",
    failed: "Check failed",
    cancelled: "Check cancelled",
  };

export type VerificationAssessmentItem =
  VerificationCheck["assessment"]["items"][number];
export type DisciplinaryAssessment = NonNullable<
  VerificationAssessmentItem["disciplinary"]
>;
